import moment from "moment";
import _ from "lodash";

export const convertTimeToMinutesAndSeconds = (data: any, path: string) => {
    const objectFromPath = _.get(data, path, 0);
    const minutes = moment(objectFromPath, 'mm:ss').minutes();
    const seconds = moment(objectFromPath, 'mm:ss').seconds();
    return minutes * 60 + seconds;
}
